import React, { Component } from "react";
import PropTypes from "prop-types";

import iconAuth from "../../../assets/img/site/loading/01.gif";
import acceptAnswer from "../../../assets/img/site/loading/06.gif";
import loadGame from "../../../assets/img/site/loading/07.gif";
import loadDashboardInfo from "../../../assets/img/site/loading/03.gif";


export default class Loading extends Component<any> {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        icon: PropTypes.oneOf([
            "auth",
            "acceptAnswer",
            "loadGame",
            "loadDashboardInfo",
        ]).isRequired,
    };

    static defaultProps = {
        icon: ""
    };

    private getIcon(): any {
        const icons = {
            auth: iconAuth,
            acceptAnswer: acceptAnswer,
            loadGame: loadGame,
            loadDashboardInfo:loadDashboardInfo,
        };

        return icons[this.props.icon];
    }

    renderLoading() {
        return (
            <img className="my_loading" src={this.getIcon()} />
        );
    }

    renderComponent() {
        return this.props.children;
    }

    render() {
        if (this.props.isLoading) {
            return this.renderLoading();
        } else {
            return this.renderComponent();
        }
    }
}
